// src/components/StatusDot.tsx
import { ApplicantStatus, CreatorStatus } from '../../types/enums.js';

interface StatusDotProps {
  status: ApplicantStatus | CreatorStatus;
}

export const StatusDot = ({ status }: StatusDotProps) => {
  const getStatusColor = (status: ApplicantStatus | CreatorStatus): string => {
    // Handle ApplicantStatus
    if (Object.values(ApplicantStatus).includes(status as ApplicantStatus)) {
      switch (status as ApplicantStatus) {
        case ApplicantStatus.APPLIED:
          return 'bg-gray-500';
        case ApplicantStatus.IN_REVIEW:
          return 'bg-purple-500';
        case ApplicantStatus.SAMPLE_REQUESTED:
          return 'bg-yellow-500';
        case ApplicantStatus.OFFER_SENT:
          return 'bg-blue-400';
        case ApplicantStatus.REJECTED:
          return 'bg-red-400';
      }
    }
    
    // Handle CreatorStatus
    switch (status as CreatorStatus) {
      case CreatorStatus.PENDING:
        return 'bg-yellow-500';
      case CreatorStatus.ACTIVE:
        return 'bg-green-500';
      case CreatorStatus.INACTIVE:
        return 'bg-gray-500';
      case CreatorStatus.SUSPENDED:
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <div className={`w-2.5 h-2.5 rounded-full ${getStatusColor(status)}`} />
  );
};